import { createLocation } from 'history';
import { flow } from 'lodash/fp';

import {
  push as pushRoute,
  replace as replaceRoute,
  goBack,
  goForward,
} from 'connected-react-router';

const createHelper =
  (goToRoute, { setCurrentLocation, initMatchedRoute }) =>
  (path) =>
    function* () {
      flow(createLocation, setCurrentLocation)(path);

      yield initMatchedRoute();

      if (__CLIENT__) {
        global.scrollTo(0, 0);
      }

      yield goToRoute(path);
    };

export default (params) => ({
  goBack,
  goForward,
  gerHistoryLength: () => params.history.length,
  pushRoute: createHelper(pushRoute, params),
  replaceRoute: createHelper(replaceRoute, params),
});
